export default __webpack_public_path__ + "ec6c9f6f665ea9f224489aa925bda228.svg";